import React, { useState, useEffect } from 'react';
import axios from '../helpers/axiosConfig';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify'; // Importation
import getBaseUrl from '../helpers/utility';

const EditBrigade = () => {
  const { id } = useParams(); // Récupère l'ID de la brigade à partir de l'URL
  const baseUrl = getBaseUrl();

  const navigate = useNavigate();
  let token = localStorage.getItem('accessToken');

  const [brigadeData, setBrigadeData] = useState({
    name: '',
    libelle: '',
    historique: '',
    observation: '',
    reference: '',
    implantation: '',
    filename: null,
    chefDeBrigade: '',
    personnelId: null,
  });
  const [newImage, setNewImage] = useState(null);
  const [removeImage, setRemoveImage] = useState(false); // Pour gérer la suppression de l'image existante
  const [error, setError] = useState(''); // Pour gérer la suppression de l'image existante

  const handleRemoveImage = () => {
    setBrigadeData({ ...brigadeData, filename: '' });
    setRemoveImage(true); // Indiquer que l'image existante doit être supprimée
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setNewImage(file);
      setBrigadeData((prevData) => ({
        ...prevData,
        filename: file.name,
      }));
    }
    setRemoveImage(false); // Réinitialiser l'état de suppression si une nouvelle image est sélectionnée
  };

  const [personnelSuggestions, setPersonnelSuggestions] = useState([]);

  useEffect(() => {
    const fetchBrigade = async () => {
      try {
        const response = await axios.get(`brigade/show/${id}`);
        //setBrigadeData(response.data);
        const brigadeData = response.data;

        setBrigadeData({
          ...brigadeData,
          name: brigadeData.name || null,
          libelle: brigadeData.libelle || null,
          historique: brigadeData.historique || null,
          observation: brigadeData.observation || null,
          reference: brigadeData.reference || null,
          implantation: brigadeData.implantation || null,
          filename: brigadeData.filename || null,
          personnelId: brigadeData.personnelId || null,
          chefDeBrigade: brigadeData.personnel ? brigadeData.personnel.nomprenom : null,
        });

        if (brigadeData.personnelId) {
          const personnelResponse = await axios.get(`personnel/show/${brigadeData.personnelId}`);
          setBrigadeData({
            ...brigadeData,
            chefDeBrigade: personnelResponse.data.nomprenom || null,
          });
        }
      } catch (error) {
        console.error('Voir > EditBrigade.js eseEffect() du route brigade api/id/show/ :', error);
      }
    };
    fetchBrigade();
  }, []);

  // Fetch personnel suggestions based on input
  const handleChefDeBrigadeChange = async (e) => {
    console.log(e);
    const query = e.target.value.toLowerCase().trim();

    setBrigadeData({
      ...brigadeData,
      chefDeBrigade: e.target.value,
    });

    if (query.length >= 1) { 
      try {
        const res = await axios.get(`personnel/`, {
          params: {
            nomprenom: query,
          },
          headers:{
            Authorization: `Bearer ${token}`,
          }
        });
        console.log(res.data);
        //const limitResult = res.data.slice(0, 10)
        const filtreResultat = res.data
          .filter((personnel) => {
            const nomComplet = (personnel.nomprenom || '').toLowerCase();
            return query.split(' ').every((term) => nomComplet.includes(term));
          })
          .slice(0, 10);
        setPersonnelSuggestions(filtreResultat);
      } catch (error) {
        console.error('Erreur lors de la récupération des suggestions de personnels', error);
      }
    } else {
      setPersonnelSuggestions([]);
      setBrigadeData({
        ...brigadeData,
        chefDeBrigade: null,
        personnelId: null,
      });
    }
  };

  // Handle personnel selection
  const handlePersonnelSelect = (personnel) => {
    setBrigadeData({
      ...brigadeData,
      chefDeBrigade: personnel.nomprenom,
      personnelId: personnel.id,
    });
    setPersonnelSuggestions([]);
  };

  // Handle form input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setBrigadeData({ ...brigadeData, [name]: value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append('brigadeData', JSON.stringify(brigadeData));

    if (newImage) {
      const fixedImageName = `${brigadeData.name}_${newImage.name}`;
      formData.append('file', newImage, fixedImageName);
    } else if (removeImage) {
      formData.append('removeImage', true);
    } else {
      // Garder l'image existante si aucune modification
      formData.append('filename', brigadeData.filename);
    }

    try {
      const response = await axios.put(`brigade/${id}/edit`, formData);

      if (response.data.success) {
        toast.success('Enregistrement Brigade avec succès !', {
          position: 'bottom-right',
        });
        setTimeout(() => {
          navigate('/brigade');
        }, 2000);
      }
    } catch (error) {
      setError(error.response.data.error);
      toast.error("Erreur lors de l'enregistrement", {
        position: 'bottom-right',
      });
    }
  };

  return (
    <div className="container mt-5 pt-3 ">
      <h2>Modifier la Brigade</h2>
      <div className="row">
        <div className="col ">{error && <div className="alert alert-danger "> {error} </div>}</div>
      </div>
      <form encType="multipart/form-data" onSubmit={handleSubmit}>
        <div className="row">
          <div className="col">
            <label htmlFor="libelle">Libellé</label>
            <input type="text" className="form-control" id="libelle" name="libelle" value={brigadeData.libelle} onChange={handleChange} />
          </div>
          <div className="col">
            <label htmlFor="name">Name</label>
            <input type="text" className="form-control" id="name" name="name" value={brigadeData.name} onChange={handleChange} />
          </div>
          <div className="col">
            <label htmlFor="historique">Historique</label>
            <input className="form-control" id="historique" name="historique" rows="3" value={brigadeData.historique} onChange={handleChange} />
          </div>
        </div>
        <div className="row">
          <div className="col">
            <label htmlFor="observation">Observation</label>
            <input className="form-control" id="observation" name="observation" rows="3" value={brigadeData.observation} onChange={handleChange} />
          </div>
          <div className="col">
            <label htmlFor="reference">Référence</label>
            <input type="text" className="form-control" id="reference" name="reference" value={brigadeData.reference} onChange={handleChange} />
          </div>
          <div className="col">
            <label htmlFor="implantation">Implantation</label>
            <input type="text" className="form-control" id="implantation" name="implantation" value={brigadeData.implantation} onChange={handleChange} />
          </div>
        </div>
        <div>
          <label>Chef de Brigade</label>
          <input type="text" name="chefDeBrigade" value={brigadeData.chefDeBrigade} onChange={handleChefDeBrigadeChange} placeholder="Entrez le nom du chef de brigade" className="form-control" />
          {personnelSuggestions.length > 0 && (
            <ul>
              {personnelSuggestions.map((personnel) => (
                <li className="bg-primary" key={personnel.id} onClick={() => handlePersonnelSelect(personnel)} style={{ cursor: 'pointer' }}>
                  {personnel.nomprenom}
                </li>
              ))}
            </ul>
          )}
        </div>

        <div className="row">
          <div className="col">
            <label htmlFor="image">Image de la Brigade</label>
            <input type="file" onChange={handleImageChange} className="form-control-file" id="image" name="file" />
          </div>

          <img src={`${baseUrl}/images/brigades/${brigadeData.filename}`} alt="Brigade" style={{ width: '400px', height: 'auto', objectFit: 'cover' }} />
          <div onClick={handleRemoveImage}>
            <i className="fa fa-trash"></i>Supprimer l'image
          </div>
          <button
            type="button"
            style={{
              position: 'absolute',
              top: '0',
              right: '0',
              border: 'none',
              cursor: 'pointer',
              padding: '5px',
              borderRadius: '50%',
            }}
          ></button>
        </div>
        <button type="submit" className="btn btn-primary mt-4 ">
          Enregistrer les modifications
        </button>
      </form>
    </div>
  );
};

export default EditBrigade;
